import SearchAndOrder from '@core/interfaces/bpc-search-and-order';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { Invoice } from '@accounting/interfaces/invoice';
import InvoiceDetails from '@accounting/components/details/invoice-details/invoice-details.vue';
import { POSTicket, POSTicketDetail } from '@pos/interfaces/pos-v2';

@Component({
  name: 'bpc-invoice-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-std-filter': StdFilter,
    'bpc-invoice-details': InvoiceDetails,
  },
})
export default class PosTicketTable extends mixins(AbstractTable) {
  declare $refs: AbstractTable['$refs'];

  @Prop(String) declare readonly title: string;
  @Prop(String) declare readonly subtitle: string;
  @Prop({ type: Boolean, default: false })
  readonly showActionButtonText: boolean;
  @Prop(Array) readonly accountingJournalsType: string[];
  @Prop({ type: Boolean, default: false })
  readonly validateInvoicePageAction: boolean;
  @Prop({ type: Boolean, default: false }) readonly sendInvoiceAction: boolean;
  @Prop({ type: Boolean, default: false })
  readonly syncInvoicePageAction: boolean;
  @Prop({ type: Boolean, default: true })
  readonly bulkMoveToTrashPageAction: boolean;
  @Prop({ type: Boolean, default: false })
  readonly bulkAddToDirectDebitFilePageAction: boolean;
  @Prop({ type: Boolean, default: false })
  readonly markInvoicesAsPaidPageAction: boolean;
  @Prop({ type: Boolean, default: false }) readonly ignoreURLParams: boolean;
  @Prop({ type: Number }) readonly posSessionId: number;

  public entity: Invoice = null;
  public entityName = 'invoice';
  public pluralEntityName = 'invoices';
  public permissionEntityNameToUse = 'invoices';
  public invoiceDetailsModalTitle = '';
  public invoiceCode = '';

  // Common state for bulk actions
  public searchAndOrder: SearchAndOrder = null;

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];
  readonly errorMessageText: string = 'global.generic.error_form_action';

  public posTicketDetailModalTitle;

  get pageActions() {
    return {
      ...this.customPageActions,
      ...this.defaultPageActions,
    };
  }

  customRowActions = {
    openTicket: {
      activated: false,
      type: 'action',
      icon: 'edit',
      show: false,
      event: 'open-ticket',
      text: 'open',
      permissions: ['show'],
    },
    viewTicket: {
      activated: true,
      type: 'action',
      icon: 'eye',
      show: true,
      event: 'view-ticket',
      text: 'view',
      permissions: ['show'],
    },
    printTicket: {
      activated: true,
      type: 'action',
      icon: 'print',
      show: true,
      event: 'print-ticket',
      text: 'print',
      permissions: ['show'],
    },
  };

  get rowActions() {
    return {
      ...this.defaultRowActions,
      ...this.customRowActions,
    };
  }

  extendUpdateRowActions(entity: any) {
    // TODO JJFC : how to identify a closed ticket? status = paid? only
    if (entity.pos_session_id === this.posSessionId && entity.in_pos_checkout) {
      entity.actions.openTicket.show = true;
      entity.actions.openTicket.activated = true;
    }
    entity.actions.printTicket.show = true;
    entity.actions.printTicket.activated = true;
  }

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'open-ticket':
        this.openTicket($event.item);
        break;
      case 'view-ticket':
        this.viewTicket($event.item);
        break;
      case 'print-ticket':
        this.printTicket($event.item);
        break;
    }
  }

  printTicket(item): void {
    const ticket: POSTicketDetail = item.item;
    this.$emit('print-ticket', ticket);
  }

  openTicket(item): void {
    const ticket: POSTicket = item.item;
    this.$emit('open-ticket', ticket);
  }

  viewTicket(item): void {
    const ticket: POSTicket = item.item;
    this.$emit('view-ticket', ticket);
  }

  // LIFECYCLE

  //mounted() {}

  //destroyed() {}
}
